/**
 * Created by Ning Jiang on 4/1/2016.
 */

import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { SoundConfig } from "../../SoundConfig";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { ScreenEvent } from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import { INolimitAudioPlayer } from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import { TimelineMax } from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class SoundManager {

    protected static currentLoop:string = "";

    private static get soundPlayer():INolimitAudioPlayer{
        return <INolimitAudioPlayer>SlotGame.sound;
    }

    constructor(){
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => {
            SoundManager.playAmbientLoop(SoundConfig.instance.BASE_GAME_AMBIANCE2,1,0);
            SoundManager.playAmbientLoop(SoundConfig.instance.BASE_GAME_AMBIANCE);
        });
    }
 
    public static playAmbientLoop(name:string, duration?:number, volume?:number):void {
        this.currentLoop = name;
        this.soundPlayer.playTrack({
            name: this.currentLoop,
            volume: volume
        });
    }

    public static StartFSMusic():void {

        this.soundPlayer.fadeTrack({
            name: SoundConfig.instance.BASE_GAME_AMBIANCE,
            to: 0,
            duration:1,
        });
        this.soundPlayer.fadeTrack({
            name: SoundConfig.instance.BASE_GAME_AMBIANCE2,
            to: 0,
            duration:1,
        });

        this.currentLoop = SoundConfig.instance.FS_GAME_AMBIANCE;
        this.soundPlayer.playTrack({
            name: this.currentLoop,
            volume: 1
        });
    }

    public static SwitchFStoMain(playFsEnding: boolean = true): void {

        this.fadeAndStop(SoundConfig.instance.FS_GAME_AMBIANCE, 254)
        this.soundPlayer.stopTrack(SoundConfig.instance.MANIAC_1);
        this.soundPlayer.stopTrack(SoundConfig.instance.MANIAC_2);

        // #241
        playFsEnding && this.soundPlayer.playTrack({name: SoundConfig.instance.FS_ENDS});

        this.currentLoop = SoundConfig.instance.BASE_GAME_AMBIANCE;
        this.soundPlayer.playTrack({
            name: this.currentLoop,
            volume: 0
        });
        this.soundPlayer.fadeTrack({
            name:this.currentLoop,
            to:1,
            duration:2000
        })
    }


    public static playManiac1():void {
        this.fadeAndStop(SoundConfig.instance.FS_GAME_AMBIANCE, 100);

        this.soundPlayer.playTrack({
            name:SoundConfig.instance.MANIAC_1,
        });
    }

    public static playManiac2():void {
        this.soundPlayer.stopTrack(SoundConfig.instance.MANIAC_1);
        this.soundPlayer.playTrack({
            name:SoundConfig.instance.MANIAC_2,
            repeat:Number.MAX_SAFE_INTEGER
        });
    }


    private static isBigwin:boolean = false;

    public static fadeForBigWin(volume:number, duration:number):void{
        this.isBigwin = true;
        this.soundPlayer.fadeTrack({
            name:SoundConfig.instance.BASE_GAME_AMBIANCE2,
            duration:duration,
            to:volume
        });
        this.soundPlayer.fadeTrack({
            name:this.currentLoop,
            duration:duration,
            to:volume
        });
    }


    public static endForBigWin(volume:number, duration:number):void{
        this.isBigwin = false;

        this.soundPlayer.fadeTrack({
            name:this.currentLoop,
            duration:duration,
            to:volume
        });
    }

    public static playSoundEffect(name:string, repeat?:number, volume?:number):void {
        this.soundPlayer.playTrack({
            name:name,
            repeat:repeat,
            volume:volume,
        });
    }

    public static playkeypadEffect(name:string):void {
        this.soundPlayer.playKeypadSound(name);
    }

    public static stopSoundEffect(name:string,fadeOutDuration?:number):void {
        if (fadeOutDuration && fadeOutDuration > 1) {
            this.fadeAndStop(name, fadeOutDuration)
        } else {
            this.soundPlayer.stopTrack(name);
        }
    }


    private static fadeAndStop(name:string, duration:number){
        this.soundPlayer.fadeTrack({
            name:name,
            to:0,
            duration:duration
        });
        setTimeout(()=> {
            this.soundPlayer.stopTrack(name);
        }, duration)

    }

    private static winTl:TimelineMax;
    public static playNormalWinFade():void {

        this.soundPlayer.fadeTrack({
            name: SoundConfig.instance.BASE_GAME_AMBIANCE,
            duration:100,
            to:0
        })
        this.soundPlayer.fadeTrack({
            name: SoundConfig.instance.BASE_GAME_AMBIANCE2,
            duration:100,
            to:1
        })

        this.winTl = Helper.timeLineKiller(this.winTl ,new TimelineMax({
            onComplete:()=> {
                if(this.currentLoop === SoundConfig.instance.BASE_GAME_AMBIANCE && !this.isBigwin){
                    this.soundPlayer.fadeTrack({
                        name: SoundConfig.instance.BASE_GAME_AMBIANCE,
                        duration:9000,
                        to:1
                    })
                }
                this.soundPlayer.fadeTrack({
                    name: SoundConfig.instance.BASE_GAME_AMBIANCE2,
                    duration:9000,
                    to:0
                })
            }
        }))
        this.winTl.to(this,15,{});
    }

    public static onFadeLoopTrack(duration:number, to:number, from?:number):void {
        this.soundPlayer.fadeTrack({
            name:this.currentLoop,
            duration:duration,
            to: to,
            from: from
        });
    }

    public static onFadeSoundEffect(name:string, volume:number, duration:number):void {
        this.soundPlayer.fadeTrack({
            name:name,
            duration:duration,
            to:volume,
        });
    }
}